var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M 16.658 13.476 L 36.524 33.342 C 36.896 33.714 36.896 34.318 36.524 34.689 L 34.689 36.524 C 34.318 36.896 33.714 36.896 33.342 36.524 L 13.476 16.658 C 13.104 16.286 13.104 15.682 13.476 15.311 L 15.311 13.476 C 15.682 13.104 16.286 13.104 16.658 13.476 Z","style":{"stroke":"none","fill":"#043250","strokeMiterlimit":"10"},"key":0}),React.createElement("path",{"d":"M 13.476 33.342 L 33.342 13.476 C 33.714 13.104 34.318 13.104 34.689 13.476 L 36.524 15.311 C 36.896 15.683 36.896 16.286 36.524 16.658 L 16.658 36.524 C 16.286 36.896 15.682 36.896 15.311 36.524 L 13.476 34.69 C 13.104 34.318 13.104 33.714 13.476 33.342 Z","style":{"stroke":"none","fill":"#043250","strokeMiterlimit":"10"},"key":1})]);
}

CloseInline.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"0 0 50 50","width":"50pt","height":"50pt"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
